/**
 * Implements Trending state
 */
import { ITrendingItem } from '@kattana-io/common';
import { SET } from '../actions/trending';

export interface ITrendingReducer {
  loading: boolean;
  isError: boolean,
  items: ITrendingItem[];
}

const defaultState = {
  loading: true,
  isError: false,
  items: [],
};

const trendingReducer = (
  state: ITrendingReducer = defaultState,
  action: any
) => {
  switch (action.type) {
  case SET:
    return {
      ...state,
      loading: false,
      ...action.payload,
    };
  default:
    return state;
  }
};
export default trendingReducer;
